module.exports = __webpack_public_path__ + "img/garry-smith.a835a445.jpg";